import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {Role} from '../../graphql/auth';

interface RoleData {
    role: Role
}

export const gqlRole = `
  id
  name
  ident
  description
  active
  level
  permissions {
    id
    ident
    name
  }
  users {
    id
    first_name
    last_name
    email
  }
`;

export const GET_ROLE_QUERY = gql`
    query getRole($id: Int!){
        role(id: $id){
          ${gqlRole}
        }
    }
`;

export const getRole = (id: Number) => useQuery<RoleData>(
    GET_ROLE_QUERY,
    {
        variables: {id}
    }
);

export default getRole;
